import React, { useState } from 'react';
import AllowanceOperations from './AllowanceOperations';
import EconomyOverview from '../components/Economy/EconomyOverview';
import './DashboardView.css';
import './WeeklyAllowance.css';

function WeeklyAllowance() {
    const [refreshCounter, setRefreshCounter] = useState('0');

    function refreshOperation() {
        var newRefreshCounter = refreshCounter + 1;
        setRefreshCounter(newRefreshCounter);
    }

    return (

        <div className="weeklyallowancegrid-container">
            <div className="weeklyallowancegrid-item weeklyallowancegrid-item1">
                <AllowanceOperations
                    refreshTrigger={refreshOperation} />
            </div>
            <div className="weeklyallowancegrid-item weeklyallowancegrid-item2">
                <EconomyOverview refreshTrigger={refreshCounter} />
                {/* todo - sende inn en prop som sier refresh. så kan vi ha en lytter på den */}
                {/* <iframe
                    className="iframeUkepenger"
                    src="https://kidsasparekontosbanken20191012020911.azurewebsites.net/Balance/"
                    title="Ukepenger"
                    key={refreshCounter}
                    onLoad={console.log('weeklyAllowanceOnLoad')} /> */}
            </div>
        </div>
    );
}

export default WeeklyAllowance;